import { STORAGE_KEY } from '../../constants/generic';
import {
  getDefaultLocale,
  getLocaleMessages,
  resolveAppLocale
} from '../../i18n/locales';

// Only a locale that actually ships is ever loaded: anything unresolvable - an
// unsupported browser language, garbage in localStorage, a stale brand value -
// falls back through getDefaultLocale (itself validated) instead of the old
// throwing require('../../i18n/' + locale) that white-screened the app before
// the first render (TODO §16). The resolved value is what gets persisted, so a
// bad stored locale heals itself on the next visit.
export function setLanguage(locale) {
  const resolved = resolveAppLocale([locale]) || getDefaultLocale();

  window.localStorage.setItem(STORAGE_KEY.LOCALE, resolved);

  return {
    type: 'SET_LANGUAGE',
    payload: {
      locale: resolved,
      messages: getLocaleMessages(resolved)
    }
  };
}
